import {Session} from "next-auth";
import {signOut} from "next-auth/react";
import React, {useState} from "react";
import {
  Box,
  Button,
  Flex,
  HStack,
  Stack,
  Table,
  TableContainer,
  Text,
  Tr,
  VStack,
  Tbody,
  Td
} from "@chakra-ui/react";
import {UserProfileData} from "@app/core-app/app/usecase/fetch-user-profile";
import {CiInboxIn, CiInboxOut} from "react-icons/ci";
import {event} from "../../../services/analytics";
import {CancelModal} from "./CancelModal";
import {ProfileService} from "@app/core-app/app/service/profile-service";


export type ProfileInfoBarProps = {
    session: Session
    data: UserProfileData | undefined
    className?: string
    children: any
    onCancelClick: (params: { reason: string, comment: string }) => Promise<any>
}
export const ProfileInfoBar2 = ({session, className, data, children, onCancelClick}: ProfileInfoBarProps) => {

  const impersonating = !!(session as Session & { token?: { impersonatorEmail?: string } })?.token?.impersonatorEmail
  const [showDetails, setShowDetails] = useState(false)
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const handleCancelSubscription = () => {
    setIsCancelModalOpen(true);
  };

  const handleConfirmCancellation = (reason: string, comment?: string) => {
    if (onCancelClick) {
      onCancelClick({reason, comment: comment || ""})
        .finally(() => setIsCancelModalOpen(false))
    }
  };

  return <Box backgroundColor={"white"} rounded={"base"} overflow={"hidden"} shadow={"base"} padding={[5]}>

    <HStack justifyContent={"space-between"}>
      <VStack alignItems={"start"} spacing={0} fontSize={"sm"}>
        {/*<Text fontSize={"sm"}>Logged in as:</Text>*/}
        <Text>{session?.user?.email}</Text>
      </VStack>
      <Button
        size={"xs"}
        variant={"link"}
        onClick={() =>
          impersonating
            ? (window.location.href = "/api/stop-impersonate")
            : signOut({callbackUrl: "/"})
        }
      ><span>Log out</span></Button>
    </HStack>

    {data && !data.billingData &&
          <HStack alignItems={"start"} flexWrap={"wrap"} fontSize={"sm"}>
            <Text>Free plan</Text>
          </HStack>
    }


    {data && data.billingData && <HStack alignItems={"start"} flexWrap={"wrap"} fontSize={"sm"}>
      <Box fontSize={"sm"}>
        {data.billingData?.product}
      </Box>
      <Box>|</Box>
      <Box>
        {data.billingData?.status}
      </Box>
          ${data.billingData?.status == "Active" &&
          <>
            <Box>|</Box>
            <Box cursor={"pointer"} onClick={handleCancelSubscription}>Cancel</Box>
            <CancelModal
              isOpen={isCancelModalOpen}
              onClose={() => setIsCancelModalOpen(false)}
              onConfirm={handleConfirmCancellation}
            />
          </>}

          ${data.billingData?.status == "Cancelled" &&
          <>
            <Box>expires</Box>
            <Box>{new Date(data.billingData.endsAt || new Date()).toDateString()}</Box>
          </>}

    </HStack>
    }


    {data && data.usageData && <VStack alignItems={"start"} fontSize={"sm"} spacing={0}>
      <HStack alignItems={"start"} flexWrap={"wrap"} spacing={1}>
        <Text>Usage:</Text>
        <HStack>
          <Flex alignItems={"center"}>
            <CiInboxIn size={16}/>
            <Text mx={0.5}>{data.usageData.savedEmails} {!data.profile.premium ? "/ 100" : ""}</Text>
          </Flex>
          <Flex alignItems={"center"}>
            <CiInboxOut size={16}/>
            <Text mx={0.5}>{data.usageData.sentEmails} {!data.profile.premium ? "/ 50" : ""}</Text>
          </Flex>
        </HStack>
      </HStack>
      {data?.profile.suspended && <Box fontSize="xs" color={"pink.500"}>
        <Text>Your account is suspended because usage exceed plan limits.</Text>
        <Text>Please Upgrade your account or contact support.</Text>
      </Box>}


      <Text fontSize={"sm"} cursor={"pointer"} color={"gray.600"}
        onClick={() => {
          setShowDetails((prevState) => !prevState)
          event({action: "show_usage_details", params: {}})

        }}>{showDetails ? "Hide" : "Show"} usage
            details</Text>


      {showDetails &&
              <VStack alignItems={"start"} fontSize={"sm"} spacing={2} py={0}>
                <Stack spacing={0}>
                  <Text fontWeight={"medium"} pt={1}>Last 31 days:</Text>
                  <TableContainer>
                    <Table variant='simple' size={"sm"}>
                      <Tbody>
                        <Tr>
                          <Td px={0}>Saved Emails</Td>
                          <Td>{data.usageData.savedEmails} / {ProfileService.getSavingLimit(data.profile)}</Td>
                        </Tr>
                        <Tr>
                          <Td px={0}>Sent Emails</Td>
                          <Td>{data.usageData.sentEmails} / {ProfileService.getSendingLimit(data.profile)}</Td>
                        </Tr>
                        <Tr>
                          <Td px={0}>Bounce Rate</Td>
                          <Td>{data.profile.reputation?.bounceRate ?? 0}%</Td>
                        </Tr>
                        <Tr>
                          <Td px={0}>Compliant Rate</Td>
                          <Td>{data.profile.reputation?.complaintRate ?? 0}%</Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Stack>
                <Stack spacing={0} mt={2}>
                  <Text>Free version monthly limitations:</Text>
                  <Flex pl={0} alignItems={"center"}>
                    <CiInboxIn size={16}/>
                    <Text mx={1}>Save up to 100 emails in Notion</Text>
                  </Flex>
                  <Flex pl={0} alignItems={"center"}>
                    <CiInboxOut size={16}/>
                    <Text mx={1}>Send up to 50 emails from Notion</Text>
                  </Flex>
                </Stack>
                  
              </VStack>

      }
    </VStack>
    }

    {children}

  </Box>
}
